<!-- START Work Info form -->

<form class="sidebar__form" [formGroup]="form">
	<div class="form--edit-mode">
		<div class="form-field--row grid no-padding">

			<div class="form-field col-12">
				<label class="label" for="workTrip">
					{{'bookingDetails.label.areYouTravelling' | ibeadmin:'sync'}}
				</label>
				<div class="radios-group">
					<fieldset>
						<div class="radios-group--inline">
							<div class="radio">
								<label class="radio__label" for="is_work_travel-yes">
									{{'bookingDetails.label.yes' | ibeadmin:'sync'}}
								</label>
								<input 
									class="radio__input" value='yes' 
									id="is_work_travel-yes" 
									name="workTrip" 
									type="radio"
									formControlName="workTrip">
								<div tabindex="0" class="radio__bullet"></div>
							</div>
							<div class="radio">
								<label class="radio__label" for="is_work_travel-no">
									{{'bookingDetails.label.no' | ibeadmin:'sync'}}
								</label>
								<input 
									class="radio__input" 
									value='no' 
									id="is_work_travel-no" 
									name="workTrip" 
									type="radio"
									formControlName="workTrip">
								<div tabindex="0" class="radio__bullet"></div>
							</div>
						</div>
					</fieldset>
				</div>
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					*ngIf="form.controls['workTrip'].invalid && form.touched">
					{{ formWorkErrors('workTrip') | ibeadmin:'sync' }}
				</span>
			</div>
			
		</div>
	</div>
</form>	
		
<!-- END Work Info form -->